export default "__VITE_ASSET__uADGViOt__"